module.exports = __webpack_public_path__ + "static/img/logo-title-06.e9e555a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-title-06.png
// module id = dK3C
// module chunks = 82